import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=b56daad0&scoped=true"
import script from "./goodList.vue?vue&type=script&lang=js"
export * from "./goodList.vue?vue&type=script&lang=js"
import style0 from "./goodList.vue?vue&type=style&index=0&id=b56daad0&prod&scoped=true&lang=scss"
import style1 from "./goodList.vue?vue&type=style&index=1&id=b56daad0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56daad0",
  null
  
)

export default component.exports